import * as printFunctions from '../../../actions/sales/DispatchPrintFunctions';
import DispatchInstructionSingleReportMutation from 'graphql/mutations/sales/DispatchInstructionSingleReportMutation.graphql';
import DispatchInstructionReportMutation from 'graphql/mutations/sales/DispatchInstructionReportMutation.graphql';
import { customerDocument } from '../../../utils/mailMergeFields';
import { EntityType } from '../../../@types/entityTypes';
import { ReportType } from '../../schema/p4types';

const ConformityCertificate: EntityType = {
  type: 'DispatchInstruction',
  screenReference: 'DISPATCH_INSTRUCTIONS',
  generate: DispatchInstructionSingleReportMutation,
  generateRange: DispatchInstructionReportMutation,
  printFunctions: printFunctions,
  title: 'Certificates of Conformity',
  formTitle: 'Print Certificates of Conformity',
  configuration: {
    title: 'Certificate of Conformity',
    field: 'conformityCertificateDefault',
    reportType: ReportType.ConformityCertificate,
    customerField: 'customerConformityCertificateDefault',
    receiveFlag: 'receiveConformityCertificates',
  },
  mergeFields: [
    ...customerDocument,
    {
      key: 'orderReference',
      text: 'Order Reference',
    },
    {
      key: 'salesOrderNumber',
      text: 'Sales Order Number',
    },
  ],
};

export default ConformityCertificate;
